import { Link } from 'react-router-dom';
import { TESTIDS } from '@/constants/testIds';

const LOGO_URL = '/images/anuruchi-logo.png';
const MAPRIX_LOGO = '/images/maprix-logo.jpg';

export default function Footer() {
  return (
    <footer data-testid={TESTIDS.FOOTER} className="bg-[#1B3A6B] text-[#F9F3E8]">
      {/* Decorative top border */}
      <div className="h-1 bg-gradient-to-r from-transparent via-[#C9922C] to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Col 1: Logo & Tagline */}
          <div>
            <img src={LOGO_URL} alt="अनुरुची मसाले" className="h-20 mb-4" />
            <p className="font-hindi text-[#C9922C] text-lg mb-2">अब प्यार के साथ स्वाद भी!!</p>
            <p className="text-[#F9F3E8]/70 text-sm leading-relaxed">
              Manufactured by<br />
              <span className="text-[#F9F3E8] font-semibold">Maprix Industries Pvt. Ltd.</span>
            </p>
          </div>

          {/* Col 2: Quick Links */}
          <div>
            <h4 className="font-cinzel text-sm tracking-[0.2em] uppercase text-[#C9922C] mb-6">Quick Links</h4>
            <div className="flex flex-col gap-3">
              {[
                { label: 'Home', path: '/' },
                { label: 'About Us', path: '/about' },
                { label: 'Products', path: '/products' },
                { label: 'B2B Clients', path: '/clients' },
                { label: 'Contact', path: '/contact' },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-[#F9F3E8]/70 hover:text-[#C9922C] transition-colors text-sm"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Col 3: Contact & Maprix */}
          <div>
            <h4 className="font-cinzel text-sm tracking-[0.2em] uppercase text-[#C9922C] mb-6">Contact Us</h4>
            <div className="space-y-3 text-sm text-[#F9F3E8]/70">
              <p>MIDC Jalgaon, Maharashtra</p>
              <p>
                <a href="tel:+917774926163" className="hover:text-[#C9922C] transition-colors">
                  +91-7774926163
                </a>
              </p>
              <p>
                <a href="mailto:maprixindustries115@gmail.com" className="hover:text-[#C9922C] transition-colors">
                  maprixindustries115@gmail.com
                </a>
              </p>
            </div>
            <div className="mt-6">
              <img src={MAPRIX_LOGO} alt="Maprix Industries" className="h-12 rounded opacity-80" />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#C9922C]/20">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-[#F9F3E8]/50">
          <p>&copy; 2025 Maprix Industries Pvt. Ltd. All rights reserved.</p>
          <p>FSSAI Lic. No. 21524031001278 | MIDC Jalgaon</p>
        </div>
      </div>
    </footer>
  );
}
